/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Tag_RecoveryInputs */

const en_for_whom_tag_recovery = /** @type {(inputs: For_Whom_Tag_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recovery`)
};

const pl_for_whom_tag_recovery = /** @type {(inputs: For_Whom_Tag_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regeneracja`)
};

/**
* | output |
* | --- |
* | "Recovery" |
*
* @param {For_Whom_Tag_RecoveryInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_tag_recovery = /** @type {((inputs?: For_Whom_Tag_RecoveryInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Tag_RecoveryInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_tag_recovery(inputs)
	return en_for_whom_tag_recovery(inputs)
});